import clsx from 'clsx'
import React, { FC } from 'react'

import { YOLOFlagIcon } from '@Components/Icons/YOLOFlagIcon'
import { useSplitTest } from '@Globals/SplitTests/Hooks'

import styles from './PhonePrefixItem.module.scss'

interface PhonePrefixProp{
  countryCode: string
}
export interface PhonePrefixItemProps{
  prefix?: PhonePrefixProp
  title: string
}

export const PhonePrefixItem: FC<PhonePrefixItemProps> = ({ prefix, title }) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')

  if (!prefix) {
    return null
  }
  return (
    <div className={clsx(styles.phonePrefixItem, cofDesignV1 && styles.cofDesignV1)}>
      <YOLOFlagIcon country={prefix.countryCode.replace('/', '-')} />
      <p>{title}</p>
    </div>
  )
}
